// extracted by mini-css-extract-plugin
export default {"compareMapsContainer":"CompareMaps_compareMapsContainer__e5Pqo","seperator":"CompareMaps_seperator__2Lvsw"};